var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66274 11.6508L6.99998 11.9589L7.33722 11.6508C8.53756 10.5542 9.44484 9.53047 10.0552 8.59069C10.6624 7.6559 11 6.76687 11 5.95C11 3.56288 9.23676 1.83334 6.99998 1.83334C4.7632 1.83334 2.99998 3.56288 2.99998 5.95C2.99998 6.76687 3.33758 7.6559 3.94473 8.59069C4.55512 9.53047 5.4624 10.5542 6.66274 11.6508ZM6.99998 6.5C6.63446 6.5 6.33331 6.19886 6.33331 5.83334C6.33331 5.46781 6.63446 5.16667 6.99998 5.16667C7.3655 5.16667 7.66665 5.46781 7.66665 5.83334C7.66665 6.19886 7.3655 6.5 6.99998 6.5ZM6.99998 1.66667C9.18939 1.66667 11.1666 3.33645 11.1666 5.95C11.1666 6.78356 10.8306 7.74345 10.0855 8.84193C9.3949 9.85997 8.371 10.9701 6.99998 12.1722C5.62896 10.9701 4.60506 9.85997 3.91449 8.84193C3.16937 7.74345 2.83331 6.78356 2.83331 5.95C2.83331 3.33645 4.81057 1.66667 6.99998 1.66667Z",
    fill: "#545D5B",
    stroke: "#545D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.e56475e15c4e390c30cbd6b647391a8f.svg";
export { ForwardRef as ReactComponent };